export default {
  leastDrawn: 'En az çıkan',
  mostDrawn: 'En çok çıkan',
  leastPlayed: 'En az oynanan',
  mostPlayed: 'En çok oynanan',
  drawFrom: 'Çekiliş kaynağı',
  h: 's', // short hours
  startingIn: 'Başlıyor',
  waitingForDrawnFrom: 'Çekiliş kaynağı bekleniyor',
  displayingDrawFrom: 'Gösterilen çekiliş kaynağı',
  lotteryDraw: 'Piyango çekilişi',
  eventId: 'Etkinlik ID',
  bettingShortcuts: 'Bahis kısayolları',
  draw: 'Çekiliş',
  next5Events: 'Sonraki {value} gösteriliyor',
  events: 'Etkinlikler',
  schedule: 'Program',
  next: 'Sonraki',
  event: 'Etkinlik',
  later: 'Daha sonra',
  statistics: 'İstatistikler',
  lastnRounds: 'Son {value} tur',
  bettingOffer: 'Bahis Teklifi',
  notDisplayed: 'Gösterilmiyor',
  latestResults: 'Sonuçlar',
  drawnAt: '{value} tarihinde çekildi',
  additionalBetting: 'Ek bahis',
  drawSumEvenOdd: 'Çekiliş toplamı Tek mi Çift mi',
  drawSumTotal: 'Çekiliş toplamı',
  drawSumRange: 'Çekiliş toplam aralığı',
  waitingForDrawNo: '{value} numaralı çekiliş bekleniyor',
  nextDraw: 'Sonraki çekiliş',
  waitingForDraw: 'Çekiliş bekleniyor',
  drawCompleted: 'Çekiliş tamamlandı',
  drawDisplayTemporarilyNotAvailable: 'Çekiliş görüntüleme geçici olarak kullanılamıyor',
  connectionError: 'Bağlantı hatası!',
  reconnecting: 'Yeniden bağlanılıyor...',
  number: 'Numara',
  headerNumberDescriptionUp: 'Etkinlik',
  headerNumberDescriptionDown: 'Numara',
};
